import { alertDialog } from "@rivtn/noseur";

export const PreviewLink = {

    STYLE: {
        borderRadius: 20,
        border: "5px solid #373636",
    },

    buildView: (style: any, maximized: boolean, link: string, simulateDesktop?: boolean) => {
        const dialog = alertDialog({
            style,
            cancel: null,
            confirm: null,
            componentProps: { maximized, contentProps: { style: { padding: 0, margin: 0, borderRadius: 20 } } },
            message: <div className="preview-view">
                <iframe src={link} style={simulateDesktop ? { width: 1500 } : undefined} />
                <div className="control">
                    <i className="fa fa-times" onClick={() => dialog.hide()} />
                </div>
            </div>
        });
        return dialog;
    },

    mobile: (link: string, isMobile: boolean) => {
        if (isMobile) {
            PreviewLink.buildView(PreviewLink.STYLE, true, link).show();
            return;
        }
        PreviewLink.buildView({ ...PreviewLink.STYLE, minWidth: 320, minHeight: 600, maxWidth: "98%" }, false, link).show();
    },

    desktop: (link: string, isMobile: boolean) => {
        PreviewLink.buildView(PreviewLink.STYLE, true, link, isMobile).show();
    },

}